import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import _ from 'lodash';
import store from './../../../store/store.module';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {FETCH_PARTNER_PRODUCT_REQUESTED} from "../list/list.actions";
import {
  CREATE_GHOST_PRODUCTS_COMPLETED,
  CREATE_GHOST_PRODUCTS_REQUESTED,
  LIST_GHOST_PRODUCTS_REQUESTED, PRINT_GHOST_PRODUCT_COMPLETED,
  PRINT_GHOST_PRODUCT_REQUESTED, PRINT_GHOST_PRODUCT_SUCCEEDED
} from "./ghost.actions";
import {GET_ALL_CATEGORIES_REQUESTED} from "../../category/category.actions";
import {GET_ALL_PROVIDERS_REQUESTED} from "../../provider/provider.actions";
import {GET_ALL_PROCESS_TYPES_REQUESTED} from "../../process-types/process-type.actions";
import {ApiService} from "../../../api/api.service";
import {AppInjector} from "../../../app-injector";
import ArrayList from "../../../models/ArrayList";
import { SwalComponent } from '@toverux/ngx-sweetalert2';
declare let $: any;
const dictionary = {
  "KIDS SH": "Kids Shoe",
  "KIDS CL": "Kids Cloth",
  "KIDS JW": "Kids Jewellery",
  "KIDS AC": "Kids Accessory",
  "KIDS BG": "Kids Bag",
  "ADULT AC": "Adult Accessories",
  "ADULT SH": "Adult Shoe",
  "ADULT CL": "Adult Cloth",
  "ADULT JW": "Adult Jewellery",
  "ADULT BG": "Adult Bag"
};
@Component({
  selector: 'app-ghost',
  templateUrl: './ghost.component.html',
  styleUrls: ['./ghost.component.scss']
})
export class GhostComponent implements OnInit, OnDestroy {
  public store = store;
  public categoryList = [];
  public defaultGhostProduct = {
    categories: [null],
    process_type_id: null,
    provider_id: null,
    quantity: 1
  };
  public newGhostProductPercentage = 0;
  public newGhostProduct = {
    ...this.defaultGhostProduct
  };
  public popupShown = false;
  @ViewChild('afterprint') private afterprint: SwalComponent;

  constructor(private notification: NotificationService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {
    store.dispatch({ type: GET_ALL_CATEGORIES_REQUESTED });
    store.dispatch({ type: GET_ALL_PROVIDERS_REQUESTED });
    store.dispatch({ type: GET_ALL_PROCESS_TYPES_REQUESTED });

    store.dispatch({ type: LIST_GHOST_PRODUCTS_REQUESTED });

    let subscribeProduct = store.subscribe(() => {
      let observedCode = (store as any).getState().Product.ghost.observedCode;
      if (observedCode) {
        this.newGhostProductPercentage = 0;
        AppInjector.get(ApiService).general.asyncStatus(observedCode, 1000, (val) => {
          this.newGhostProductPercentage = val.data.percentage;
        }).subscribe(s => {
          if (s !== 'Time out') {
            store.dispatch({ type: CREATE_GHOST_PRODUCTS_COMPLETED });
            store.dispatch({ type: LIST_GHOST_PRODUCTS_REQUESTED });
          }
        });
      }
      if (this.popupShown === false) {
        let printCompleted = (store as any).getState().Product.ghost.printCompleted;
        if (printCompleted) {
          this.popupShown = true;
          this.afterprint.show().then((res) => {
            this.afterPrinted(res.value);
          });
        }
      }
    });

    let subscribeCategory = store.subscribe(() => {
      let observedCode = (store as any).getState().Category.all.fetched;
      if (observedCode) {
        subscribeCategory();
        this.categoryList = [];
        (store as any).getState().Category.all.items
          .filter(s => {
            let code = (s.main_code === 'K' ? 'KIDS' : 'ADULT') + ' ' + s.type_code;
            if (typeof dictionary[code] !== 'undefined') {
              return true;
            } else {
              return false;
            }
          }).map(s => {
            let code = (s.main_code === 'K' ? 'KIDS' : 'ADULT') + ' ' + s.type_code;
            s.simple_text = dictionary[code];
            return s;
          }).forEach(s => {
            if (!this.categoryList.find(val => val.simple_text === s.simple_text)) {
              this.categoryList.push(s);
            }
        });
      }
    });

    let subscribeType = store.subscribe(() => {
      let processTypes = (store as any).getState().ProcessType.all.fetched;
      let providers = (store as any).getState().Provider.all.fetched;
      if (processTypes && providers) {
        subscribeType();
        let vipType = (store as any).getState().ProcessType.all.items.find(s => s.name === 'VIP').id;
        let sgProvider = (store as any).getState().Provider.all.items.find(s => s.name === 'SG' && s.process_type_id === vipType).id;
        this.defaultGhostProduct.process_type_id = vipType;
        this.newGhostProduct.process_type_id = vipType;
        this.defaultGhostProduct.provider_id = sgProvider;
        this.newGhostProduct.provider_id = sgProvider;
      }
    });
  }

  ngOnDestroy() {
  }

  getDetailsData(jsonDetails) {
    if (!this.store.getState().Category.all.fetched ||
      !this.store.getState().ProcessType.all.fetched ||
      !this.store.getState().Provider.all.fetched) {
      return '';
    }
    let jsonData = jsonDetails.data;
    if (!Array.isArray(jsonData)) {
      return '';
    }
    return jsonData.map(s => {
      let categories = s.categories.map(category => {
        let categoryObj = this.store.getState().Category.all.items.find(allCategoryItem => allCategoryItem.id === category);
        let code = (categoryObj.main_code === 'K' ? 'KIDS' : 'ADULT') + ' ' + categoryObj.type_code;
        return dictionary[code] ? dictionary[code] : '';
      }).join(',');
      let provider = this.store.getState().Provider.all.items.find(allProviderItem => allProviderItem.id === parseInt(s.provider_id));
      let processType = this.store.getState().ProcessType.all.items.find(allProcessTypeItem => allProcessTypeItem.id === parseInt(s.process_type_id));
      return `${s.quantity} x ${categories} ${provider ? ' - ' + provider.name : ''} ${processType ? ' - ' + processType.name : ''}`;
    }).join('<br/>');
  }

  onSubmit(form) {
    if (!form.valid) {
      return;
    }
    this.store.dispatch({
      type: CREATE_GHOST_PRODUCTS_REQUESTED, data: [this.newGhostProduct]
    });
    this.newGhostProduct = {
      ...this.defaultGhostProduct
    };
    form.submitted = false;
  }
  print(code, data) {
    this.popupShown = false;
    if (!data) {
      return;
    }
    this.store.dispatch({
      type: PRINT_GHOST_PRODUCT_REQUESTED, skus: data.split(',').map(s => {
        return {
          sku: s
        };
      }), code
    });
  }
  afterPrinted(res) {
    if (res === true) {
      this.store.dispatch({
        type: PRINT_GHOST_PRODUCT_COMPLETED
      });
    } else {
      this.store.dispatch({
        type: PRINT_GHOST_PRODUCT_SUCCEEDED
      });
    }
  }
  confirmPrint() {
    return true;
  }
  parseInt(val) {
    return val ? parseInt(val) : '';
  }
}
